import { render, staticRenderFns } from "./bioaqian.vue?vue&type=template&id=5aaeed20&scoped=true"
import script from "./bioaqian.vue?vue&type=script&lang=js"
export * from "./bioaqian.vue?vue&type=script&lang=js"
import style0 from "./bioaqian.vue?vue&type=style&index=0&id=5aaeed20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaeed20",
  null
  
)

export default component.exports